import { BaseModel } from "sjs-base-model";

export default class ProductInfoModel extends BaseModel {
    public readonly idCanale: number = 0;
    public readonly idSegmento: number = 0;
    public readonly idProdotto: number = 0;
    public readonly rata: number = 0;
    public readonly durata: number = 0;
    public readonly tan: number = 0;

    constructor(data: Partial<ProductInfoModel>) {
        super();

        this.update(data);
    }
}
